import * as Yup from 'yup';

// Validation schema for individual user registration
export const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    phoneNumber: Yup.string().required("Phone Number is required").test(
        "len",
        "Phone number must be between 2 and 15 digits",
        value => {
            const digits = value ? value.replace(/\D/g, "") : "";
            return digits.length >= 2 && digits.length <= 15;
        }
    ),
    faaIDType: Yup.string().required("FAA ID Type is required"),
    //faaIDValue: Yup.string().required("FAA Part107/44809 Registration ID is required").max(16),

  });

// Validation schema for organization user registration (FAA fields optional)
export const organizationValidationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    phoneNumber: Yup.string().required("Phone Number is required").test(
        "len",
        "Phone number must be between 2 and 15 digits",
        value => {
            const digits = value ? value.replace(/\D/g, "") : "";
            return digits.length >= 2 && digits.length <= 15;
        }
    ),
    faaIDType: Yup.string(), // Optional for organization admins
    //faaIDValue: Yup.string().max(16), // Optional
  });


  export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};